import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Services from "@/components/sections/Services";
import Stats from "@/components/sections/Stats";
import Quoter from "@/components/sections/Quoter";
import Process from "@/components/sections/Process";
import Team from "@/components/sections/Team";
import Testimonials from "@/components/sections/Testimonials";
import ClientLogos from "@/components/sections/ClientLogos";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#0a0a0a] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Stats />
      <Quoter />
      <Process />
      <Team />
      <Testimonials />
      <ClientLogos />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
}
